import { Box, Button, Typography } from "@mui/material";
import { FC } from "react";
import CustomPopup from "../CustomPopup/CustomPopup";
import { ChevronLeft } from "@mui/icons-material";
import { Colors } from "../../styles/constant";
import useCmsPageVariables from "../../hooks/useCmsPageVariables";
import { defaultEmptyFun } from "../../utils/helper";

interface PolicyAndConditionsComponentProps {
  title: string;
  open: boolean;
  handleOpen: Function;
  className?: string;
  btnLabel?: string;
  btnStartIcon?: any;
  isAcceptBtnVisible?: boolean;
  acceptBtnFun?: any;
}

const PolicyAndConditionsComponent: FC<PolicyAndConditionsComponentProps> = ({
  title,
  open,
  handleOpen,
  className = "",
  btnLabel = "",
  btnStartIcon = null,
  isAcceptBtnVisible = false,
  acceptBtnFun = defaultEmptyFun,
}) => {
  const cmsDa = useCmsPageVariables(title);
  const descriptionByParagraph = cmsDa?.attributes.text.split("\n");

  const renderCustomPopupChildren = () => {
    return (
      <Box
        alignItems={"center"}
        padding={"1rem"}
        className="terms-and-condition-wrapper"
      >
        <Typography
          textAlign={"center"}
          marginBottom={"1.5rem"}
          variant="h6"
          letterSpacing={".0938rem"}
          fontFamily={"PoppinsSemiBold"}
          color={Colors.darkCharcoal}
          className="tac-title"
        >
          {cmsDa?.attributes.title}
        </Typography>
        {descriptionByParagraph &&
          descriptionByParagraph.map((paragraph, index) => (
            <Typography
              key={paragraph}
              variant="subtitle2"
              fontSize={12}
              color="#202428"
              textAlign={"left"}
              fontFamily={"PoppinsRegular"}
              className="tac-description"
              marginTop={
                paragraph.startsWith("Declaration:") ? ".625rem" : "0rem"
              }
            >
              {paragraph}
            </Typography>
          ))}
        {isAcceptBtnVisible && (
          <Button
            fullWidth
            variant="contained"
            onClick={acceptBtnFun}
            sx={{ marginTop: "1rem" }}
          >
            Accept
          </Button>
        )}
      </Box>
    );
  };

  return (
    <CustomPopup
      open={open}
      handleOpen={handleOpen}
      btnLabel={btnLabel ? btnLabel : "Go back"}
      btnStartIcon={
        btnStartIcon ? (
          btnStartIcon
        ) : (
          <ChevronLeft sx={{ width: "1rem", height: "1rem" }} />
        )
      }
      className={className}
      children={renderCustomPopupChildren()}
    />
  );
};

export default PolicyAndConditionsComponent;
